var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "18"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1.394 16.697 9.88 1.593l8.484 15.104zm18.298.264L10.328.291a.51.51 0 0 0-.45-.251.51.51 0 0 0-.448.25L.066 16.961a.517.517 0 0 0 .448.766h18.729a.516.516 0 0 0 .45-.766z"
    }
  }), _c('path', {
    attrs: {
      "d": "M9.206 5.66v5.989c0 .227.182.407.454.407.226 0 .454-.18.454-.407V5.66c0-.227-.182-.408-.454-.408-.226 0-.454.18-.454.408m-.362 8.71a.816.816 0 1 0 1.632.002.816.816 0 0 0-1.632-.002"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }